import { render, staticRenderFns } from "./AnswerCounter.vue?vue&type=template&id=5955d072"
import script from "./AnswerCounter.vue?vue&type=script&lang=js"
export * from "./AnswerCounter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports